import React from 'react'
import { SignInCTA, SmallNotificationContainer } from './styled'

export interface SmallNotificationBannerProps {
  message: string
  ctaText: string
  'data-test'?: string
  className?: string
  onSignInClick: () => void
}

export const SmallNotificationBanner = ({
  message,
  ctaText,
  'data-test': dataTest,
  onSignInClick,
  ...rest
}: SmallNotificationBannerProps): JSX.Element => {
  return (
    <SmallNotificationContainer {...rest} data-test={dataTest || undefined}>
      <span>{message}</span>
      <SignInCTA onClick={onSignInClick}>{ctaText}</SignInCTA>
    </SmallNotificationContainer>
  )
}

SmallNotificationBanner.displayName = 'SmallNotificationBanner'

export default SmallNotificationBanner
